var _LOCAL_DOMAIN;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore
import { history } from 'umi';
import { getSessionStorage } from "./sessionStorage";
import { getPortalCodeFromUrl } from "./getPortalCodeFromUrl";
import { findSiteData } from "./valueGet";
import { getLocalStorage } from "./localStorage";
import { getCookie } from "./globalCookie";
import { message } from 'antd';
var TAG_KEYS = /*#__PURE__*/function (TAG_KEYS) {
  TAG_KEYS["workbench"] = "workbench";
  TAG_KEYS["portal"] = "portal";
  TAG_KEYS["middle"] = "middle";
  TAG_KEYS["train"] = "train";
  TAG_KEYS["userCenter"] = "user-center";
  return TAG_KEYS;
}(TAG_KEYS || {}); // 用户中心（组织管理&交易）
/** 判断当前是否为就业站点 */
var judgeIsJyAlias = function judgeIsJyAlias(tempAlias) {
  if (tempAlias === 'qznlsz') {
    return true;
  } else {
    return tempAlias.includes('qznlsx');
  }
};

// 当前域名
var currentOrigin = window.location.origin;
var LOCAL_DOMAIN = (_LOCAL_DOMAIN = {}, _defineProperty(_LOCAL_DOMAIN, TAG_KEYS.workbench, 'http://localhost:8021'), _defineProperty(_LOCAL_DOMAIN, TAG_KEYS.portal, 'http://localhost:8031'), _defineProperty(_LOCAL_DOMAIN, TAG_KEYS.middle, 'http://localhost:9061'), _defineProperty(_LOCAL_DOMAIN, TAG_KEYS.userCenter, 'http://localhost:8011'), _LOCAL_DOMAIN);
var getDomain = function getDomain(platform) {
  var _DEVELOPMENT_DOMAIN;
  var _getLocalStorage = getLocalStorage('SITE_STORE'),
    siteData = _getLocalStorage.siteData;
  var portalDomain = findSiteData(siteData, 'burl', {
    findKey: 'baseInfo'
  });
  var orgDomain = findSiteData(siteData, 'orgDomain', {
    findKey: 'baseInfo'
  });
  var pcDomain = findSiteData(siteData, 'pcDomain', {
    findKey: 'baseInfo'
  });
  var midDomain = findSiteData(siteData, 'midDomain', {
    findKey: 'baseInfo'
  });
  // const loginUrl = findSiteData(siteData, 'loginUrl', { findKey: 'baseInfo' });

  var DEVELOPMENT_DOMAIN = (_DEVELOPMENT_DOMAIN = {}, _defineProperty(_DEVELOPMENT_DOMAIN, TAG_KEYS.workbench, orgDomain), _defineProperty(_DEVELOPMENT_DOMAIN, TAG_KEYS.portal, portalDomain), _defineProperty(_DEVELOPMENT_DOMAIN, TAG_KEYS.middle, midDomain), _defineProperty(_DEVELOPMENT_DOMAIN, TAG_KEYS.userCenter, pcDomain), _defineProperty(_DEVELOPMENT_DOMAIN, TAG_KEYS.train, pcDomain), _DEVELOPMENT_DOMAIN);
  if (RUN_ENV === 'local') {
    // 创培特殊处理
    if (platform === TAG_KEYS.train) {
      return pcDomain;
    }
    return LOCAL_DOMAIN[platform];
  }
  return DEVELOPMENT_DOMAIN[platform];
};
var getFullPathname = function getFullPathname(pathname, platform) {
  if (platform === TAG_KEYS.portal) {
    // 获取门户别名
    var currentAlias = getPortalCodeFromUrl({
      isGetDomain: true
    });
    return "".concat(getDomain(platform), "/").concat(currentAlias).concat(pathname);
  }
  return "".concat(getDomain(platform)).concat(pathname);
};

/**
 *
 * @param type 类型 history 使用umi的history方法，location 使用window.location.href targetTag
 * @param pathname 需要跳转的路径
 * @param targetTag  需要跳转到的父应用的tag，默认从getSessionStorage('PLATFORM')，为了处理跨主应用跳转的问题
 */
var push = function push() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'history';
  var pathname = arguments.length > 1 ? arguments[1] : undefined;
  var targetTag = arguments.length > 2 ? arguments[2] : undefined;
  // 1. 使用方式为umi的history
  if (type === 'history') {
    return history.push(pathname);
  }
  var platform = getSessionStorage('PLATFORM');

  // 2. 使用方式为window.location
  // 可能有从workbench跳转到user/portal/middle/train情况
  if (platform === TAG_KEYS.workbench) {
    if (!targetTag) {
      // PC 机构工作台
      return window.location.href = getFullPathname(pathname, platform);
    }
    platform = targetTag;
  }

  // PC 中台
  if (platform === TAG_KEYS.middle) {
    var siteAlias = getCookie('ALIAS');
    if (judgeIsJyAlias(siteAlias)) {
      return window.location.href = getFullPathname(pathname, TAG_KEYS.middle);
    }
    return window.location.href = getFullPathname(pathname, TAG_KEYS.workbench);
  }

  // PC 用户中心
  if (platform === TAG_KEYS.userCenter) {
    if (!getDomain(TAG_KEYS.userCenter)) {
      return message.error('站点信息暂无用户中心地址', 3);
    }
    window.location.href = getFullPathname(pathname, platform);
  }

  // PC门户 | 职培
  if ([TAG_KEYS.portal, TAG_KEYS.train].includes(platform)) {
    return window.location.href = getFullPathname(pathname, platform);
  }

  // 独立子应用
  window.location.href = "".concat(currentOrigin).concat(pathname);
};

/**
 *
 * @param type 类型 history 使用umi的history方法，location 使用window.location.href targetTag 需要跳转到的父应用的tag，默认从getSessionStorage('PLATFORM')
 * @param pathname 需要跳转的路径
 * @param targetTag  需要跳转到的父应用的tag，默认从getSessionStorage('PLATFORM')，为了处理跨主应用跳转的问题
 */
var replace = function replace() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'history';
  var pathname = arguments.length > 1 ? arguments[1] : undefined;
  var targetTag = arguments.length > 2 ? arguments[2] : undefined;
  // 1. 使用方式为umi的history
  if (type === 'history') {
    return history.replace(pathname);
  }
  var platform = targetTag || getSessionStorage('PLATFORM');

  // 2. 使用方式为window.location
  // 可能有从workbench跳转到user/portal/middle/train情况
  if (platform === TAG_KEYS.workbench) {
    if (!targetTag) {
      // PC 机构工作台
      return window.location.replace(getFullPathname(pathname, platform));
    }
    platform = targetTag;
  }

  // PC 中台
  if (platform === TAG_KEYS.middle) {
    var siteAlias = getCookie('ALIAS');
    if (judgeIsJyAlias(siteAlias)) {
      return window.location.replace(getFullPathname(pathname, TAG_KEYS.middle));
    }
    return window.location.replace(getFullPathname(pathname, TAG_KEYS.workbench));
  }

  // PC 用户中心
  if (platform === TAG_KEYS.userCenter) {
    if (!getDomain(TAG_KEYS.userCenter)) {
      return message.error('站点信息暂无用户中心地址', 3);
    }
    return window.location.replace(getFullPathname(pathname, platform));
  }

  // PC门户 | 职培
  if ([TAG_KEYS.portal, TAG_KEYS.train].includes(platform)) {
    return window.location.replace(getFullPathname(pathname, platform));
  }

  // 独立子应用
  window.location.replace("".concat(currentOrigin).concat(pathname));
};
var pushState = function pushState(query, title, pathname, targetTag) {
  var platform = targetTag || getSessionStorage('PLATFORM');

  // PC门户
  if (platform === TAG_KEYS.portal) {
    return window.history.pushState(query, title, getFullPathname(pathname, platform));
  }
  return window.history.pushState(query, title, pathname);
};
var PTHistory = {
  push: push,
  replace: replace,
  pushState: pushState,
  goBack: history.goBack,
  goForward: history.goForward,
  go: history.go
};
export default PTHistory;